import { forwardRef, useEffect, useState } from 'react'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

interface SessionExpirySnackbarProps {
  getTimeRemaining: () => number
  onExtendSession: () => void
  onTimeExpired?: () => void
}

export const SessionExpirySnackbar = forwardRef<HTMLDivElement, SessionExpirySnackbarProps>(
  ({ getTimeRemaining, onExtendSession, onTimeExpired }, ref) => {
    const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining())

    useEffect(() => {
      const interval = setInterval(() => {
        const remaining = getTimeRemaining()
        setTimeRemaining(remaining)

        if (remaining <= 0) {
          clearInterval(interval)
          onTimeExpired?.()
        }
      }, 1000)

      return () => clearInterval(interval)
    }, [getTimeRemaining, onTimeExpired])

    const minutes = Math.floor(timeRemaining / 60)
    const seconds = timeRemaining % 60
    const timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`

    return (
      <Alert ref={ref} severity="warning" variant="filled" sx={{ maxWidth: 600 }}>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            alignItems: 'center',
            flexWrap: 'nowrap'
          }}
        >
          <Typography>
            Your session will expire in: <b>{timeDisplay}</b>
          </Typography>
          <Button
            variant="text"
            size="small"
            onClick={onExtendSession}
            sx={{
              color: 'text.primary',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'action.hover'
              }
            }}
          >
            EXTEND SESSION
          </Button>
        </Box>
      </Alert>
    )
  }
)
